import { createRoot } from "react-dom/client";
import { getSidebarCustomize } from ".";
/**
 * Allows to prepend an React node before a section li-element.
 *
 * @param sections
 */ function addContentBesideSection(sections) {
    const customize = getSidebarCustomize();
    for (const sectionId of Object.keys(sections)){
        var _customize_section, _customize_control;
        let opts = {};
        const Component = sections[sectionId];
        if (typeof Component === "function") {
            opts.render = Component;
            opts.type = "before";
        } else {
            opts = Component;
        }
        const liElement = ((_customize_section = customize.section(sectionId)) == null ? void 0 : _customize_section.container.get(0)) || ((_customize_control = customize.control(sectionId)) == null ? void 0 : _customize_control.container.get(0));
        if (!liElement) {
            return;
        }
        const renderNode = document.createElement("div");
        if (opts.type === "before") {
            liElement.before(renderNode);
        } else {
            liElement.after(renderNode);
        }
        createRoot(renderNode).render(opts.render(liElement));
    }
}
export { addContentBesideSection };
